import { Box, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";
import { formatDate } from "../../../helpers/dateFormatter";

export const LoanRepaymentSchedule: React.FC<BaseTablePropsType> = ({ rows }) => {
    const loanRepaymentScheduleHeaders = ["Date", "Amount To Pay", "Penalty", "Principal Amount", "Interest", "Balance", "Status"];

    return (
        <BaseTable headers={loanRepaymentScheduleHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{formatDate(row?.dueDate, false)}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.amount ?? 0)}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.penalty ?? 0)}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.principal ?? 0)}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.interest ?? 0)}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.balance ?? 0)}</TableCell>
                            <TableCell>
                                <Box
                                    borderRadius={"8px"}
                                    padding={"calc(var(--basic-padding)/4)"}
                                    bgcolor={row?.status === "paid" ? "var(--active-green-color)" : "var(--text-salmon-pink-color)"}
                                >
                                    <Typography
                                        fontFamily={"Poppins"}
                                        fontWeight={"600"}
                                        fontSize={14}
                                        lineHeight={"normal"}
                                        color={"var(--light-color)"}
                                        whiteSpace={"normal"}
                                    >
                                        {row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}
                                    </Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
